import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSvgoComponent } from './simple-icons-svgo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSvgoComponent ],
    exports:      [ SimpleIconsSvgoComponent ],
    bootstrap:    []
})
export class SimpleIconsSvgoModule {}
